import { useSelector } from 'react-redux';

import { AuthStepKey } from '@/components/pages/Authentication/types';
import { selectAccountSlug } from '@/redux/session/selectors';
import { AuthStepType } from '@/shared/types/tryIt';

import { useDialogAction } from './useDialogAction';
import { useLeaveModal } from './useLeaveModal';
import { selectBrainId } from '../redux/selectors';

const STEP_QUERY_PARAM: Partial<Record<AuthStepType, AuthStepKey>> = {
  [AuthStepType.IDENTIFICATION]: 'identification',
  [AuthStepType.VERIFICATION]: 'verification',
};

type AuthQuestionArgs = { actionId?: string; step?: AuthStepType; questionKey?: string };

type AuthQuestionLink = { to: string; goTo: () => void };

export const useGoToAuthQuestion = ({
  actionId,
  step,
  questionKey,
}: AuthQuestionArgs): AuthQuestionLink | null => {
  const leaveModal = useLeaveModal();
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);
  const dialogId = useDialogAction(actionId)?.dialog_id;

  if (!slug || !brainId || !dialogId) {
    return null;
  }

  const stepParam = step ? STEP_QUERY_PARAM[step] : undefined;
  const search = new URLSearchParams();
  if (stepParam) {
    search.set('step', stepParam);
  }
  if (questionKey) {
    search.set('question', questionKey);
  }
  search.set('action', actionId as string);
  const to = `/${slug}/ai-agents/${brainId}/workflows/dialogs/${dialogId}?${search.toString()}`;

  return { to, goTo: () => leaveModal(to) };
};
